import {BigDecimal} from '@dms/api/shared';

import type {TenantBankAccount} from './TenantBankAccount';

export type DepositPaymentCardPaymentRequestBody = {
  paymentDiscriminator: DepositPaymentCardPaymentRequestBody.paymentDiscriminator;
  paymentMethod: DepositPaymentCardPaymentRequestBody.paymentMethod;
  dueDate: string;
  amount: BigDecimal;
  comment: string;
  tenantBankAccount?: TenantBankAccount | null;
  cashRegisterId: string;
  createCashRegisterDocument: boolean | null;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace DepositPaymentCardPaymentRequestBody {
  export enum paymentDiscriminator {
    DEPOSIT = 'DEPOSIT',
  }

  export enum paymentMethod {
    PAYMENT_CARD = 'PAYMENT_CARD',
  }
}
